import { createSelector, Selector } from 'reselect';
import { RootState } from '../../../redux/root-reducer';
import { IThspianPlaylist } from '../../../types/global/helper';
import { projectSelector } from '../../../pages/UserProjects/selector';

export const userPlaylistSelector: Selector<RootState, IThspianPlaylist[]> = createSelector(
    [projectSelector],
    project => project.userPlaylist ?? [],
);
